import type { LucideIcon } from 'lucide-react'
import {
  Bot,
  CircleHelp,
  Columns2,
  FolderTree,
  Layers,
  LayoutPanelLeft,
  Map,
  PanelLeft,
  PanelTop,
  Puzzle,
  Search,
  Sparkles,
  UserRound,
} from 'lucide-react'

/** Clipart for tour cards - mirrors the live chrome control where possible. */
const PRODUCT_TOUR_STEP_ICONS: Record<string, LucideIcon> = {
  welcome: Map,
  search: Search,
  profile: UserRound,
  help: CircleHelp,
  'panel-toggles': Columns2,
  'workspace-picker': Layers,
  'workspace-list': Layers,
  'icon-bar': PanelLeft,
  'icon-bar-extensions': Puzzle,
  sidebar: FolderTree,
  'main-panel': LayoutPanelLeft,
  'tab-bar': PanelTop,
  'agent-panel': Bot,
  done: Sparkles,
}

export function ProductTourStepIcon({
  stepId,
  className,
}: {
  stepId: string
  className?: string
}) {
  const Icon = PRODUCT_TOUR_STEP_ICONS[stepId]
  if (!Icon) return null
  return (
    <div
      className={
        className ??
        'mb-3 flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10 text-primary'
      }
      aria-hidden
    >
      <Icon className="h-5 w-5" strokeWidth={1.75} />
    </div>
  )
}
